import { createSlice } from "@reduxjs/toolkit";

const scrollPositionSlice = createSlice({
  name: "scrollPosition",
  initialState: {
    scrollPosition: 0,
    activeYear: -1,
  },
  reducers: {
    setScrollPosition: (state, action) => {
      state.scrollPosition = action.payload;
    },
    setActiveYear: (state, action) => {
      state.activeYear = action.payload;
    },
  },
});

export const { setScrollPosition, setActiveYear } = scrollPositionSlice.actions;
export default scrollPositionSlice.reducer;
